module.exports = __webpack_public_path__ + "img/progress-4.b622c099.jpg";